// import crypto from 'crypto';
import { getCookie, setCookie } from 'utils';

/**
 * Store client password as a cookie
 */
const _setAuthenticated = (eventId, pin) => setCookie(`${eventId}_pin`, pin);

/**
 * Get client password from cookie
 */
const _getPIN = eventId => getCookie(`${eventId}_pin`);

/**
 * Sha1 encrypt input string
 * @param {String} pin - the pin (user input or cookie value)
 * @private
 */
// const _encryptPIN = async pin => {
//     console.log('SHA-1-1-1', pin);
//     const hash = await window.crypto.subtle.digest('SHA-1', new TextEncoder().encode(pin));
//     console.log('SHA-1-2-2', hash);
//     return hash;
// }
const _encryptPIN = async pin => {
    const encoder = new TextEncoder();
    const data = encoder.encode(pin);
    const hashBuffer = await crypto.subtle.digest('SHA-1', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
};
// crypto
//     .createHash('sha1')
//     .update(pin)
//     .digest('hex');

/**
 * Store client password as a cookie
 */
const _setAuthenticated__legacy = (eventId, firstName) => setCookie(`${eventId}_${firstName.toLowerCase()}_in`, true);

/**
 * Get client password from cookie
 */
const _getIsAuthenticated__legacy = (eventId, firstName) => getCookie(`${eventId}_${firstName.toLowerCase()}_in`);

export async function setAuth(eventId, pin) {
    _setAuthenticated(eventId, await _encryptPIN(pin));
}

export async function authenticate({ pin, eventId, firstName }, input) {
    if (pin) {
        if (pin === (await _encryptPIN(input))) {
            _setAuthenticated(eventId, pin);
            return true;
        }
        return false;
    }
    // support for legacy events (use first name from cookie)
    if (firstName.toLowerCase() === input) {
        _setAuthenticated__legacy(eventId, firstName);
        return true;
    }
    return false;
}

/**
 * Check if user is authenticated
 * @param {String} pin - encrypted pin
 * @param {String} id - eventId or streamId
 * @param {String} firstName - a user's first name (only needed for legacy users)
 * @return {boolean}
 */
export function isAuthenticated({ pin, id, firstName }) {
    if (pin) {
        return pin === _getPIN(id);
    }
    // support for legacy events (use first name from cookie)
    return !!_getIsAuthenticated__legacy(id, firstName);
}
